// "Hoje" NUNCA vem do fuso do dispositivo: use hojeUtc3() de @sheepcount/shared.

/** 'YYYY-MM-DD' → 'dd/mm/aaaa'. */
export function formatDateBR(iso: string): string {
  const [ano = '', mes = '', dia = ''] = iso.split('-');
  return `${dia}/${mes}/${ano}`;
}

/** 'YYYY-MM-DD' → 'dd/mm' (sem ano). */
export function formatDateBRCurta(iso: string): string {
  const [, mes = '', dia = ''] = iso.split('-');
  return `${dia}/${mes}`;
}

/** Instante ISO 8601 → 'dd/mm hh:mm' em UTC-3 (Brasília), nunca no fuso do dispositivo. */
export function formatDataHoraBR(isoInstante: string): string {
  const d = new Date(new Date(isoInstante).getTime() - 3 * 60 * 60 * 1000);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getUTCDate())}/${p(d.getUTCMonth() + 1)} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
}
